import { Contract } from '../../../types/contract';
import { Clock, CheckCircle, Star, XCircle, FileText } from 'lucide-react';

export const useContractStatus = (contract: Contract | undefined) => {
  // Se não há contrato, retorna valores padrão
  if (!contract) {
    return {
      statusConfig: {
        label: 'Carregando...',
        color: 'text-slate-600',
        bgColor: 'bg-slate-50',
        borderColor: 'border-slate-200',
        icon: Clock
      },
      priorityInfo: {
        color: 'from-slate-500 to-slate-600',
        label: 'Carregando...'
      },
      urgencyAlert: null
    };
  }

  const getStatusConfig = (status: string) => {
    const configs = {
      pendente: {
        label: 'Pendente',
        color: 'text-amber-600',
        bgColor: 'bg-amber-50',
        borderColor: 'border-amber-200',
        icon: Clock
      },
      confirmado: {
        label: 'Confirmado',
        color: 'text-emerald-600',
        bgColor: 'bg-emerald-50',
        borderColor: 'border-emerald-200',
        icon: CheckCircle
      },
      concluido: {
        label: 'Concluído',
        color: 'text-purple-600',
        bgColor: 'bg-purple-50',
        borderColor: 'border-purple-200',
        icon: Star
      },
      cancelado: {
        label: 'Cancelado',
        color: 'text-red-600',
        bgColor: 'bg-red-50',
        borderColor: 'border-red-200',
        icon: XCircle
      },
      orcamento: {
        label: 'Orçamento',
        color: 'text-blue-600',
        bgColor: 'bg-blue-50',
        borderColor: 'border-blue-200',
        icon: FileText
      }
    };
    
    return configs[status?.toLowerCase() as keyof typeof configs] || {
      label: 'Não definido',
      color: 'text-slate-600',
      bgColor: 'bg-slate-50',
      borderColor: 'border-slate-200',
      icon: Clock
    };
  };

  const getPriorityInfo = () => {
    if (!contract.dataFesta) {
      return { color: 'from-slate-500 to-slate-600', label: 'Data não definida' };
    }
    
    const today = new Date();
    const eventDate = new Date(contract.dataFesta);
    const diffTime = eventDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return { color: 'from-slate-500 to-slate-600', label: 'Evento passado' };
    if (diffDays === 0) return { color: 'from-red-500 to-red-600', label: 'Hoje' };
    if (diffDays === 1) return { color: 'from-red-500 to-red-600', label: 'Amanhã' };
    if (diffDays <= 7) return { color: 'from-red-500 to-red-600', label: 'Esta semana' };
    if (diffDays <= 30) return { color: 'from-amber-500 to-amber-600', label: 'Este mês' };
    return { color: 'from-slate-500 to-slate-600', label: 'Futuro' };
  };

  const getUrgencyAlert = () => {
    if (!contract.dataFesta) return null;
    
    const today = new Date();
    const eventDate = new Date(contract.dataFesta);
    const diffTime = eventDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return null;
    
    if (diffDays === 0) return { text: 'HOJE!', color: 'bg-red-600' };
    if (diffDays === 1) return { text: 'AMANHÃ!', color: 'bg-red-600' };
    if (diffDays <= 7) return { text: `Faltam ${diffDays} dias`, color: 'bg-red-500' };
    
    return null;
  };

  const statusConfig = getStatusConfig(contract.status);
  const priorityInfo = getPriorityInfo();
  const urgencyAlert = getUrgencyAlert();

  return { statusConfig, priorityInfo, urgencyAlert };
};
